// Review Actions
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';
import { isFetchingEndpointSelector } from 'selectors/fetchingSelectors';

export const getRentalTermsAndConditions = () => (dispatch, getState) => {
  const state = getState();
  const isFetchingRentalTermsAndConditions = isFetchingEndpointSelector(state, {
    endpoint: 'reservations/rentalTermsAndConditions',
  });
  // rentalTermsAndConditions API is getting 3times, to avoid this i am using above condition to stop duplication of API calls.
  if (isFetchingRentalTermsAndConditions) {
    return null;
  }

  return dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.reservations.rentalTermsAndConditions,
      }),
    })
  );
};
